import React, { useState, useEffect, useRef } from "react";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { useQuerySwitch } from "./Helpers";

const LiveHub = ({ entities, handleUpdate, children }) => {
    let connection = useRef<HubConnection>({} as HubConnection);
    // const [connection, setConnection] = useState(null);
    const [connected, setConnected] = useState(false);

    const ignoreConnection = useQuerySwitch("ignoreConnection");

    const connect = () => {
        if (connection) {
            connection.current
                .start()
                .then((result) => {
                    console.log("Connected!");

                    setConnected(true);
                    setPing(1);
                    handleUpdate && handleUpdate();

                    connection.current.on("updated", () => {
                        handleUpdate && handleUpdate();
                    });

                    connection.current.on("subscribed", (id) => {
                        console.log("subscribed to " + id);
                    });
                })
                .catch((e) => {
                    setConnected(false);
                    console.log("Connection failed: ", e);
                });
        }
    };

    useEffect(() => {
        const newConnection = new HubConnectionBuilder().withUrl("/hubs/live").withAutomaticReconnect().build();
        connection.current = newConnection;
        // setConnection(newConnection);
    }, []);

    useEffect(() => {
        connect();
    }, [connection]);

    useEffect(() => {
        if (connection.current && entities.length > 0) {
            if (connection.current.state == "Connected") {
                try {
                    entities.forEach(async (e) => {
                        await connection.current.send("Subscribe", e);
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        }

        return () => {
            if (connection && connection.current.state == "Connected") {
                entities.forEach(async (e) => {
                    await connection.current.send("Unsubscribe", e);
                });
            }
        };
    }, [connected, entities]);

    const [ping, setPing] = useState(1);

    React.useEffect(() => {
        let i = setTimeout(() => {
            if (ignoreConnection) {
                handleUpdate && handleUpdate();
            } else {
                if (!connection.current) {
                    setConnected(false);
                    const newConnection = new HubConnectionBuilder().withUrl("/hubs/live").withAutomaticReconnect().build();

                    connection.current = newConnection;

                    connect();
                } else if (connection.current.state != "Connected") {
                    setConnected(false);
                    const newConnection = new HubConnectionBuilder().withUrl("/hubs/live").withAutomaticReconnect().build();

                    connection.current = newConnection;

                    connect();
                }
            }
            setPing(ping + 1);
        }, 10000);

        return () => clearTimeout(i);
    }, [ping, connection]);

    return <div style={{ filter: connection?.current?.state == "Connected" || ignoreConnection ? "" : "grayscale(100)" }}>{children}</div>;
};

export default LiveHub;
